import { useEffect, useState } from "react";
import { fetchRoles, downloadRolesExcel } from "../Api/ViewRoleMaster";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewRoleMaster = () => {
  const [roles, setRoles] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadRoles = async () => {
      try {
        const data = await fetchRoles();
        setRoles(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Roles");
      }
    };

    loadRoles();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadRolesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Roles_Master_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Roles data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    
      <div className="main-content expand">
        <Container fluid className="list-container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="list-title">View Role Master</span>
            <Button className="generate-btn"
              variant="primary" 
              onClick={handleDownload}
              disabled={isDownloading || roles.length === 0}
            >
              {isDownloading ? 'Downloading...' : 'Download Data'}
            </Button>
          </div>

          {roles.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Code</th>
                      <th>Description</th>
                      <th>Created On Date</th>
                      <th>Created On Time</th>
                      <th>Created By</th>
                      <th>Changed On Date</th>
                      <th>Changed On Time</th>
                      <th>Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.map((role, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{role.code}</td>
                        <td>{role.description}</td>
                        <td>
                          {role.createdOnDate
                            ? moment(role.createdOnDate).format("L")
                            : "-"}
                        </td>
                        <td>{role.createdOnTime?.split(".")[0] || "-"}</td>
                        <td>{role.createdBy || "-"}</td>
                        <td>
                          {role.changedOnDate
                            ? moment(role.changedOnDate).format("L")
                            : "-"}
                        </td>
                        <td>{role.changedOnTime?.split(".")[0] || "-"}</td>
                        <td>{role.changedBy || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No roles found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewRoleMaster;